import { API } from '@Providers';
import type { PaymentType } from '../types';

interface CheckoutRequest {
  _id: string; // TODO AF-545 : Probably not necessary
  cart_id: string;
  checkoutFlow?: string; // TODO AF-533 - Should be an ENUM
  email: string | null;
  payment_type: PaymentType | null;
  phone: string;
  resend?: boolean;
  staff_confirmed_use_of_do_not_adopt_person?: boolean;
  show_application?: boolean | null;
  show_contract?: boolean | null;
  status: string; // TODO AF-533 - Should be an ENUM
  foster_contract_id?: string;
  foster_animals_waivers?: Array<{
    animal_id: string;
    waiver_ids: string[];
    reserve_kennel_spot?: boolean;
    start_date?: string;
    start_foster_notes?: string;
    start_foster_reason?: string;
    start_foster_reason_id?: string;
  }>;
  equipment_rental_lines?: Array<{
    line_id: string;
    rental_agreement_id?: string | null;
    due_date?: string;
    rental_notes?: string;
    rental_start_date?: string;
    agreement_title?: string;
    agreement_body?: string;
  }>;
}

export default async function (payload: CheckoutRequest) {
  const endpoint = '/api/shelter/cart/send-checkout-link';

  return API({ endpoint, method: 'post', payload });
}
